import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { useGetRegionsQuery } from 'common/store/modules/api/content-api';
import { SelectionCallout } from './SelectionCallout';
import { updateRegions, oneYearFromNow } from 'widgets/region-selector/js/util';
import { SvgIcon } from 'common/react/components/SvgIcon';
import { getTranslation } from 'common/react/utils/translations';
import { useCheckBarStatus, useCreateLocations } from '../hooks/hooks';

export const SelectionCalloutWrapper = ({ title }) => {
    const selectedTimeZone = useSelector((state) => state.selectedRegion);
    const [selectedValue, setSelectedValue] = useState(selectedTimeZone);
    const [cookieStatus, setCookieStatus] = useState(
        PULSE.core.localStorage.getStorage('regionBarStatus', true) ||
            'barInitialised'
    );
    const [calloutTextStatus, setCalloutTextStatus] = useState(
        PULSE.core.localStorage.getStorage('calloutTextStatus', true) || 'false'
    );

    const { data = [] } = useGetRegionsQuery();

    useCheckBarStatus(cookieStatus, calloutTextStatus, setCalloutTextStatus);

    //Update Cookies
    useEffect(() => {
        PULSE.core.localStorage.setStorage(
            'calloutTextStatus',
            calloutTextStatus,
            oneYearFromNow(),
            true
        );

        PULSE.core.localStorage.setStorage(
            'regionBarStatus',
            cookieStatus,
            oneYearFromNow(),
            true
        );
    }, [cookieStatus, calloutTextStatus]);

    const locations = useCreateLocations(data);

    // Event Handlers
    const handleDropdownChange = (value) => {
        setSelectedValue(value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        updateRegions(
            selectedValue.name,
            selectedValue.timezone,
            selectedValue.id,
            selectedValue.timezone.split('/')[0],
            selectedValue.timezone.split('/')[1]
        );
        setCalloutTextStatus('true');
    };

    const handleCloseBar = (event) => {
        event.preventDefault();
        setCalloutTextStatus('true');
        setCookieStatus('barClosed');
    };

    const handleCloseMessage = (event) => {
        event.preventDefault();
        setCalloutTextStatus('dismissed');
    };

    return (
        <>
            <div
                className={`selection-callout ${
                    calloutTextStatus !== 'false' ? 'u-hide' : ''
                }`}
            >
                <div className="selection-callout__text-container">
                    <SvgIcon className="selection-callout__icon" icon="globe" />
                    <p className="selection-callout__text">{title}</p>
                </div>
                <div className="selection-callout__mobile-layout">
                    {selectedTimeZone.location &&
                    selectedTimeZone.regionName ? (
                        <SelectionCallout
                            handleDropdownChange={handleDropdownChange}
                            locations={locations}
                            regions={data}
                            selectedTimeZone={selectedTimeZone}
                        />
                    ) : (
                        <></>
                    )}
                    <button
                        onClick={(event) => {
                            handleSubmit(event);
                        }}
                        className="selection-callout__submit"
                    >
                        {getTranslation(`label.button.continue`)}
                    </button>
                </div>
                <button
                    className="selection-callout__close"
                    onClick={(event) => handleCloseBar(event)}
                >
                    <SvgIcon
                        className="icon selection-callout__close-icon"
                        icon="close"
                    />
                </button>
            </div>
            {calloutTextStatus === 'true' ? (
                <div className="selection-callout__message wrapper">
                    <div className="selection-callout__message-container">
                        <SvgIcon
                            className="selection-callout__icon"
                            icon="globe"
                        />
                        <p
                            className="selection-callout__message-text"
                            dangerouslySetInnerHTML={{
                                __html: getTranslation(`region.callout.message`)
                            }}
                        ></p>
                        <button
                            className="selection-callout__close"
                            onClick={(event) => handleCloseMessage(event)}
                        >
                            <SvgIcon
                                className="icon selection-callout__close-icon"
                                icon="close"
                            />
                        </button>
                    </div>
                </div>
            ) : null}
        </>
    );
};

SelectionCalloutWrapper.propTypes = {
    title: PropTypes.string
};
